import { render } from "./JoditEditor.vue?vue&type=template&id=2aaf888a&ts=true"
import script from "./JoditEditor.vue?vue&type=script&lang=ts"
export * from "./JoditEditor.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\mccj\\source\\repos\\Jodit-Ts-Vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__